import React, { useState } from "react";
import ButtonLoading from "../Button/ButtonLoading";
import LegalbirdIoModal from "../Modal/LegalbirdIoModal";
import ApiClient from "../../services/ApiClient";

import { useSnackbar } from "notistack";
import { useCurrentUser } from "../../provider/CurrentUserProvider";
import { EmailMessage } from "../../types/EmailMessage";
import { ProductUnion } from "../../types/ProductUnion";
import dayjs from "dayjs";

type EmailTransmissionReportModalProps = {
  emailMessage: EmailMessage;
  product: ProductUnion;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
};

export default function EmailTransmissionReportModal({
  emailMessage,
  product,
  isOpen,
  setIsOpen,
}: EmailTransmissionReportModalProps) {
  const [isLoading, setIsLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const currentUser = useCurrentUser();

  const sender = emailMessage.from?.email;
  if (
    !sender ||
    (sender !== "service@legalbird.de" && sender !== "anwalt@legalbird-kanzlei.de") ||
    dayjs(emailMessage.created).add(30, "days").isBefore(dayjs(), "days")
  ) {
    return null;
  }

  const generateEmailTransmissionReport = async () => {
    setIsLoading(true);
    const data = {
      productClassName: product.productClassName,
      productId: product.id,
      mailSubject: emailMessage.messageContent.subject,
      senderEmailAddress: sender,
      recipientEmailAddress: emailMessage.to?.email,
      createdBy: currentUser["@id"],
    };
    try {
      await ApiClient.post("lb/services/backoffice_mail_transmission_report", { body: JSON.stringify(data) });
    } catch (e) {
      enqueueSnackbar("Mail-Sendebericht konnte nicht abgerufen werden", {
        variant:"custom",
        isNonInteractive  : true,
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "center",
        },
        autoHideDuration: 3000,
      });
    }
    setIsLoading(false);
    setIsOpen(false);
  };

  return (
    <LegalbirdIoModal
      handleClose={() => setIsOpen(false)}
      open={isOpen}
      disableBackdropClick
      title="Sendebericht anfordern"
      submitButton={
        <ButtonLoading onClick={() => generateEmailTransmissionReport()} variant="contained" isLoading={isLoading}>
          Sendebericht anfordern
        </ButtonLoading>
      }
    >
      <p>
        Mit dem Klick auf "Sendebericht anfordern", wird der Sendebericht für diese E-Mail im Dokumentenbereich
        angehangen.
      </p>
    </LegalbirdIoModal>
  );
}
